import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../asyncInterface";
import {
  encryptAccountNumber,
  setPrimaryAccount
} from "../../../utils/sessionUtil";
import { openAdditionalAccount } from "../../../services/apiServices";
import * as actionTypes from './actionTypes';
import { accountChangeAfterOAAType } from '../../../actions/globalActionTypes';
import history from "../../../history/history";
import { handlerServerSideErrorsGlobal } from "../../../sagas/globalSaga";


export function submitData(actionObj) {
  const { method, url, data, isBhoomiUrl} = actionObj.payload;
  const response = asyncInterface.init();
  return response.openAdditonalPhilanthropicAccount.submitData({
    method,
    url,
    data,
    isBhoomiUrl
  });
}

export function* validateSubmitWorker(actionObj) {
  try {
    const accountDetails = yield call(submitData, actionObj);
    const accountDetailsOne = accountDetails.data;

    let encrypytKey = encryptAccountNumber(
      accountDetailsOne.accountNumber
    );
    let accountObj1 = {
      role: { access: "All Access" },
      accountName: accountDetailsOne.accountName,
      currentBalance: accountDetailsOne.currentBalance ? accountDetailsOne.currentBalance : 0,
      accountType: accountDetailsOne.accountType,
      freezes: [],
    };
    accountObj1[encrypytKey] = accountDetailsOne.accountId;
    let userData = JSON.parse(sessionStorage.getItem("userData"));
    userData.Accounts.push(accountObj1);
    sessionStorage.setItem("userData", JSON.stringify(userData));
    setPrimaryAccount(accountObj1);

    yield put({ type: actionTypes.submitFormSuccess, payload: accountDetailsOne });
    yield put({
      type: accountChangeAfterOAAType,
      payload: { accountID: accountDetailsOne.accountId }
    });
    yield put({ type: actionTypes.hideSubmitLoader });
  } catch (error) {
    yield put({ type: actionTypes.submitFormError, error });
    yield put({ type: actionTypes.hideSubmitLoader });

    yield  handlerServerSideErrorsGlobal({error,type:"OAASubmitPageErr",errorCodes:[504],redirect:'/',isRedirectfirst:true});
    yield  handlerServerSideErrorsGlobal({error});
    
  }
}

export function* validateSubmitWatcher() {
  yield takeEvery(actionTypes.validateFinal, validateSubmitWorker);
}

export function* getUserDetails(payload) {
  yield put({ type: actionTypes.preFillValueAddressPrimary, payload });
}

export function* getDropdownValues(payload) {
  yield put({ type: actionTypes.preFillValuePrimary, payload });
}

export function* getZipCode(payload) {
  yield put({ type: actionTypes.preFillValueInfoPrimary, payload });
}

export function* getZipCodeWorker(fetchPayload) {
  try {
    let response = yield fetchZipCodeData(fetchPayload);
    yield put({
      type: actionTypes.fetchZipCode,
      payload: { response, fetchPayload: fetchPayload.payload }
    });
  } catch (error) {
    yield put({
      type: actionTypes.ooaAccountDataRequestFailed,
      error
    });
  }
}

export function fetchZipCodeData(fetchPayload) {
  let zipCodeData = "";
  const apiUrl = "http://ziptasticapi.com/" + fetchPayload.payload.zipCode;
  zipCodeData = fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        return null;
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (data.error) {
        return null;
      } else {
        return data;
      }
    });
  return zipCodeData;
}

export function setContribution(payload){
  openAdditionalAccount.setInitialContribution(payload);
}

export function* fetchAlertContents(){
  let alertContent = yield openAdditionalAccount.fetchAlertContents();
  if(alertContent.length){
    yield put({ type: actionTypes.fetchAlertSuccess, payload: alertContent });
  }else{
    yield put({ type: actionTypes.fetchAlertError, payload: [] });
  }
}

export function* OPADefaultWatcher() {
  yield takeEvery(actionTypes.fetchZipCodeData, getZipCodeWorker);
}

export function* fetchAlertContentWatcher(){
  yield takeEvery(actionTypes.fetchAlertContentsOaa, fetchAlertContents)
}

export function* setInitialContributionWatcher(){
  yield takeEvery(actionTypes.initialContribution, setContribution);
}

export default function* OPAWatcher() {
  yield all([fork(OPADefaultWatcher), fork(validateSubmitWatcher), fork(setInitialContributionWatcher), fork(fetchAlertContentWatcher)]);
}
